/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OrganizationUser = {
  createdAt: Date;
  /**
   * User email address.
   */
  email: string;
  /**
   * Speakeasy relationship row ID.
   */
  id: string;
  /**
   * Timestamp of the user's most recent login.
   */
  lastLogin?: Date | undefined;
  /**
   * User display name.
   */
  name: string;
  /**
   * Speakeasy organization ID.
   */
  organizationId: string;
  /**
   * User photo URL.
   */
  photoUrl?: string | undefined;
  updatedAt: Date;
  /**
   * Speakeasy user ID.
   */
  userId: string;
  /**
   * WorkOS organization membership ID when known.
   */
  workosMembershipId?: string | undefined;
};

/** @internal */
export const OrganizationUser$inboundSchema: z.ZodMiniType<
  OrganizationUser,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    email: z.string(),
    id: z.string(),
    last_login: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    name: z.string(),
    organization_id: z.string(),
    photo_url: z.optional(z.string()),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    user_id: z.string(),
    workos_membership_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "last_login": "lastLogin",
      "organization_id": "organizationId",
      "photo_url": "photoUrl",
      "updated_at": "updatedAt",
      "user_id": "userId",
      "workos_membership_id": "workosMembershipId",
    });
  }),
);

export function organizationUserFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationUser, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationUser$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationUser' from JSON`,
  );
}
